import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const createCheckoutSession = async (productId, customerEmail = null) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/payments/checkout`, {
      product_id: productId,
      customer_email: customerEmail,
      origin_url: window.location.origin
    });
    
    return response.data;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

export const getCheckoutStatus = async (sessionId) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/payments/checkout/status/${sessionId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting checkout status:', error);
    throw error;
  }
};

export const getCustomerPurchases = async (email) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/payments/purchases/${email}`);
    return response.data;
  } catch (error) {
    console.error('Error getting customer purchases:', error);
    throw error;
  }
};
